import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function STWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-2050">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-2051">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-2052">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-2053">
            WHAT IS SKINTYTE
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-2054"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-2055">
            SkinTyte by Sciton targets and heats deep tissue without damaging
            surrounding areas.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-4" data-id="element-2056">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-2057">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-2058">
              SkinTyte is awesome! It improves crepiness, laxity, fine lines and
              textural issues. It takes about 20 minutes and feels like a warm
              massage. There's no downtime! If done regularly, your collagen and
              elastin will continue to increase, reversing time and dramatically
              improving signs of aging.
            </p>
          </div>
          <p className="text-[#666666] text-sm font-body mb-12" data-id="element-2059">— Dr. Fiona</p>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-2060">
            <p data-id="element-2061">
              This process initiates the body's natural healing response,
              creating a new collagen foundation that makes loose skin appear
              tighter, plumper and more youthful. SkinTyte is considered an
              incredibly effective light-based treatment for achieving the
              appearance of younger-looking skin.
            </p>
            <p data-id="element-2062">
              At Be CLINICAL, we perform the highest number of BBL treatments
              annually in the San Francisco Bay Area. We know what we are doing!
              With over 10,000 treatments completed, we are experts at fine
              tuning settings to deliver incredible results. Trust our team of
              medical specialists to provide the safest and most effective care
              during your BBL / SkinTyte treatment.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}